<h1 mat-dialog-title>Please set Hold Until date</h1>
<div mat-dialog-content class="py-2">
  <input class="lum-input" matInput type="date" [(ngModel)]="value" />
</div>
<div mat-dialog-actions align="center">
  <button
    mat-button
    (click)="dialogRef.close()"
    class="lum-button lum-button--tertiary"
  >
    Cancel
  </button>
  <button mat-button cdkFocusInitial [mat-dialog-close]="value" class="lum-button">
    Confirm
  </button>
</div>
